export type MentionAutocompleteUser = {
	id: string
	name: string
	image?: string | null
	lastSeenAt?: Date | null
}

const MAX_MENTION_OPTIONS = 8

const normalizeSearch = (value: string) => value.trim().toLowerCase()

export const getMentionAutocompleteUsers = ({
	users,
	queryString
}: {
	users: MentionAutocompleteUser[]
	queryString: string | null
}) => {
	const query = normalizeSearch(queryString ?? "")
	return users
		.filter((user) => (query ? user.name.toLowerCase().includes(query) : true))
		.slice(0, MAX_MENTION_OPTIONS)
}
